import { render, staticRenderFns } from "./PopupAd.vue?vue&type=template&id=29d1cfc9&scoped=true&"
import script from "./PopupAd.vue?vue&type=script&lang=js&"
export * from "./PopupAd.vue?vue&type=script&lang=js&"
import style0 from "./PopupAd.vue?vue&type=style&index=0&id=29d1cfc9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d1cfc9",
  null
  
)

export default component.exports